import {
	AppGlobalNavigationItemSaveModel,
	GlobalNavigationItemKind,
	GlobalNavigationSaveModel,
	GroupGlobalNavigationItemDataSaveModel,
	GroupGlobalNavigationItemSaveModel,
	SpaceGlobalNavigationItemSaveModel,
	SpaceUserInfo
} from "client/Api/TitleBar/GlobalNavigation/globalNavigation";
import { SpaceKind } from "client/Api/Workspace/workspace";
import { ObjectWithClientId } from "client/Misc/clientId";

export type AppGlobalNavigationItemFormModel = ObjectWithClientId<AppGlobalNavigationItemSaveModel>;

export type GroupGlobalNavigationItemDataFormModel = Omit<GroupGlobalNavigationItemDataSaveModel, "children"> & {
	children: readonly GlobalNavigationItemFormModel[];
};

export type GroupGlobalNavigationItemFormModel = ObjectWithClientId<Omit<GroupGlobalNavigationItemSaveModel, "groupData"> & {
	groupData: GroupGlobalNavigationItemDataFormModel;
}>;

export type SpaceGlobalNavigationItemFormModel = ObjectWithClientId<SpaceGlobalNavigationItemSaveModel> & {
	spaceKind: SpaceKind;
	name: string;
	userInfo: SpaceUserInfo;
};

export type GlobalNavigationItemFormModel =
	| AppGlobalNavigationItemFormModel
	| GroupGlobalNavigationItemFormModel
	| SpaceGlobalNavigationItemFormModel;

export type GlobalNavigationFormModel = Omit<GlobalNavigationSaveModel, "items"> & {
	items: ObjectWithClientId<GlobalNavigationItemFormModel>[];
};

export const isSpaceItem = (item: GlobalNavigationItemFormModel): item is SpaceGlobalNavigationItemFormModel => {
	return item.kind === GlobalNavigationItemKind.Space;
};

export const isAppItem = (item: GlobalNavigationItemFormModel): item is AppGlobalNavigationItemFormModel => {
	return item.kind === GlobalNavigationItemKind.InstalledApp;
};

export const isGroupItem = (item: GlobalNavigationItemFormModel): item is GroupGlobalNavigationItemFormModel => {
	return item.kind === GlobalNavigationItemKind.Group;
};
